import breadcrumbComp from "../../common/breadcrumb-comp";
import AddFavourite from "../../utility/js/addFav.js";
import EncryptUtility from "../../utility/js/encrypt-utility.js";
import Utility from "../../../shared/utility";
import usbService from "../js/usb-services.js";
import moment from "moment";
import html2pdf from "html2pdf.js";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
export default {
  data() {
    return {
      actionList: [],
      mainPage: "",
      favouriteList: [],
      pageUrl: "",
      subPage: "",
      showAdd: false,
      subPageUrl: "",
      backSlash: true,
      refresh: true,
      userId: EncryptUtility.localStorageDecrypt("userID"),
      totalRecords: 0,
      disablePDFExport: true,
      disableExcelExport: true,
      transitOrderData: [],
      maxStartDate: new Date().toISOString().split("T")[0],
      minEndDate: new Date(new Date().setDate(new Date().getDate() - 90)).toISOString().split("T")[0],
      maxEndDate: new Date(new Date().getTime()).toISOString().split("T")[0],
      sDate: new Date(new Date().setDate(new Date().getDate() - 90)).toISOString().split("T")[0],
      eDate: "",
      showStartDate: true,
      showEndDate: true,
      startDate: false,
      endDate: false,
      detailSearch: "",
      page: 1,
      pageCount: 0,
      selectedStatus: "",
      statusList: [],
      max3Rule: [(v) => (v || "").length >= 3 || "Min Length of 3 character", (v) => (v || "").length > 0 || "Min Length of 3 character"],
    };
  },
  async created() {
    this.route = this.$route.path.replace("/", "");
    let data = await AddFavourite.getPageAction(this.userId, this.route);
    this.actionList = data.actionList;
    this.mainPage = data.mainPage;
    this.favouriteList = data.favouriteList;
    this.pageUrl = data.pageUrl;
    this.subPage = data.subPage;
    this.showAdd = data.showAdd;
    this.getStatusValues();
  },
  computed: {
    computedDateFormattedMomentjs() {
      return this.sDate ? moment(this.sDate).format("MM/DD/YYYY") : moment(new Date().getTime() - 86400000).format("MM/DD/YYYY");
    },
    computedEndDateFormattedMomentjs() {
      return this.eDate ? moment(this.eDate).format("MM/DD/YYYY") : moment(new Date()).format("MM/DD/YYYY");
    },
  },
  methods: {
    //Reset Function
    resetFunction() {
      this.totalRecords = 0;
      this.disablePDFExport = true;
      this.disableExcelExport = true;
      this.transitOrderData = [];
      this.showStartDate = false;
      this.showEndDate = false;
      this.$nextTick(() => {
        this.showStartDate = true;
        this.sDate = new Date(new Date().setDate(new Date().getDate() - 90)).toISOString().split("T")[0];
        this.showEndDate = true;
        this.eDate = null;
      });
      this.detailSearch = "";
      this.page = 1;
      this.pageCount = 0;
      this.selectedStatus = "";
      this.$refs.detailSearchForm.resetValidation();
    },
    // set end Date
    setEndDate() {
      let minEndDate = new Date(this.sDate);
      this.minEndDate = new Date(minEndDate.getTime() + 0).toISOString().substr(0, 10);
      let maxSDate = new Date(this.maxStartDate);
      this.maxEndDate = new Date(maxSDate.getTime() + 0).toISOString().substr(0, 10);
    },
    async getStatusValues() {
      let obj = {
        pass: 3,
        SearchStr: "",
        PageNumber: 1,
        export: 0,
        user_id: parseInt(this.userId),
        lcedate: new Date(new Date().getTime()).toISOString().substr(0, 10),
        lcsdate: new Date().toISOString().substr(0, 10),
        Status: this.selectedStatus,
      };
      let showMessage = false;
      let data = await usbService.getTransitOrderLogs("post", obj, showMessage);
      if (data != null && data != undefined && data != {} && data.message !== "NA") {
        this.statusList = data?.StatusInfo;
      } else {
        this.statusList = [];
      }
    },
    //Text Search
    async onTextSearch(page) {
      if (this.detailSearch !== "" && this.detailSearch !== null) {
        this.selectedStatus = "";
        this.transitOrderData = [];
        this.showStartDate = false;
        this.showEndDate = false;
        this.$nextTick(() => {
          this.showStartDate = true;
          this.sDate = new Date(new Date().setDate(new Date().getDate() - 90)).toISOString().split("T")[0];
          this.showEndDate = true;
          this.eDate = null;
        });
        let obj = {
          pass: 1,
          SearchStr: this.detailSearch,
          PageNumber: page,
          export: 0,
          user_id: parseInt(this.userId),
          lcedate: new Date(new Date().getTime()).toISOString().substr(0, 10),
          lcsdate: new Date().toISOString().substr(0, 10),
          Status: this.selectedStatus,
        };
        let showMessage = false;
        let data = await usbService.getTransitOrderLogs("post", obj, showMessage);
        if (data != null && data != undefined && data != {} && data.message !== "NA") {
          const newArr = data?.TransitOrders.map((obj) => {
            return {
              ...obj,
              devices:
                obj?.devices?.map((device) => ({
                  ...device,
                  shipped_date: device?.shipped_date ? Utility.displayDateFormat(device.shipped_date) : "",
                  updated: device?.updated ? Utility.displayDateFormat(device.updated) : "",
                })) || [],
            };
          });
          this.transitOrderData = newArr;
          this.pageCount = data?.TransitOrders[0]?.TotalPages;
          this.totalRecords = data?.TransitOrders[0]?.TotalRecords;
          this.disablePDFExport = false;
          this.disableExcelExport = false;
        } else {
          this.transitOrderData = [];
          this.pageCount = 0;
          this.totalRecords = 0;
          this.disablePDFExport = true;
          this.disableExcelExport = true;
        }
      } else {
        let Alert = {
          type: "error",
          isShow: true,
          message: "Please enter any value.",
        };
        this.$store.commit("ConfigModule/Alert", Alert);
      }
    },
    //Date Search
    async onDateSearch(page) {
      this.transitOrderData = [];
      this.detailSearch = "";
      this.$refs.detailSearchForm.resetValidation();
      let obj = {
        pass: 2,
        SearchStr: "",
        PageNumber: page,
        export: 0,
        user_id: parseInt(this.userId),
        lcedate: Utility.inputDateFormat(this.computedEndDateFormattedMomentjs, "23:59:59"),
        lcsdate: Utility.inputDateFormat(this.computedDateFormattedMomentjs, "23:59:59"),
        Status: this.selectedStatus,
      };
      let showMessage = false;
      let data = await usbService.getTransitOrderLogs("post", obj, showMessage);
      if (data != null && data != undefined && data != {} && data.message !== "NA") {
        const newArr = data?.TransitOrders.map((obj) => {
          return {
            ...obj,
            devices:
              obj?.devices?.map((device) => ({
                ...device,
                shipped_date: device?.shipped_date ? Utility.displayDateFormat(device.shipped_date) : "",
                updated: device?.updated ? Utility.displayDateFormat(device.updated) : "",
              })) || [],
          };
        });
        this.transitOrderData = newArr;
        this.pageCount = data?.TransitOrders[0]?.TotalPages;
        this.totalRecords = data?.TransitOrders[0]?.TotalRecords;
        this.disablePDFExport = false;
        this.disableExcelExport = false;
      } else {
        this.transitOrderData = [];
        this.pageCount = 0;
        this.totalRecords = 0;
        this.disablePDFExport = true;
        this.disableExcelExport = true;
      }
    },
    pageChanged(page) {
      if (this.detailSearch !== "" && this.detailSearch !== null) {
        this.onTextSearch(page);
      } else {
        this.onDateSearch(page);
      }
    },
    async exportData() {
      this.export50kData = true;
      this.exportDialog = false;
    },
    async exportToExcel() {
      if (this.totalRecords <= 15000) {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("Transit Order Logs");
        const headerStyle = {
          font: { bold: true },
          alignment: { horizontal: "center", vertical: "middle" },
          fill: { type: "pattern", pattern: "solid", fgColor: { argb: "D3D3D3" } },
        };
        const borderStyle = {
          top: { style: "thin" },
          bottom: { style: "thin" },
          left: { style: "thin" },
          right: { style: "thin" },
        };
        const deviceHeaderStyle = {
          font: { bold: true },
          alignment: { horizontal: "center", vertical: "middle" },
          fill: { type: "pattern", pattern: "solid", fgColor: { argb: "E7E6E6" } },
        };
        const deviceBorderStyle = {
          top: { style: "thin", color: { argb: "c2c2c2" } },
          bottom: { style: "thin", color: { argb: "c2c2c2" } },
          left: { style: "thin", color: { argb: "c2c2c2" } },
          right: { style: "thin", color: { argb: "c2c2c2" } },
        };
        const mainHeader = worksheet.addRow([
          "TRO Number",
          "RLP Number",
          "Status",
          "Project",
          "Ship Method",
          "Devices Shipped",
          "Devices Accepted",
          "Devices Rejected",
          "Update Message",
          "Update Details",
        ]);
        mainHeader.eachCell((cell) => {
          cell.style = headerStyle;
          cell.border = borderStyle;
        });
        this.transitOrderData.forEach((item) => {
          const troRow = worksheet.addRow([
            item.tro_number,
            item.rlp_number,
            item.status,
            item.project,
            item.ship_method,
            item.devices_shipped,
            item.devices_accepted,
            item.devices_rejected,
            item.update_message,
            item.update_details,
          ]);
          troRow.eachCell((cell) => {
            cell.border = borderStyle;
          });
          const deviceHeader = worksheet.addRow(["Serial Number", "Shipped Date", "Status", "Updated", "Update Comments", "", "", "", "", ""]);
          deviceHeader.eachCell((cell) => {
            cell.style = deviceHeaderStyle;
            cell.border = deviceBorderStyle;
          });
          const devices = item.devices?.length ? item.devices : [{}];
          devices.forEach((device) => {
            const deviceRow = worksheet.addRow([
              device.serial_number || "-",
              device.shipped_date || "",
              device.status || "",
              device.updated || "",
              device.update_comments || "",
              "",
              "",
              "",
              "",
              "",
            ]);
            deviceRow.eachCell((cell) => {
              cell.border = deviceBorderStyle;
            });
          });
          worksheet.addRow([]);
        });
        worksheet.columns.forEach((column) => {
          let maxLength = 0;
          column.eachCell({ includeEmpty: true }, (cell) => {
            const value = cell.value ? cell.value.toString() : "";
            maxLength = Math.max(maxLength, value.length);
          });
          column.width = maxLength < 14 ? 14 : maxLength + 2;
        });
        const buffer = await workbook.xlsx.writeBuffer();
        saveAs(new Blob([buffer]), Utility.excelNewFileName("Transit_Orders_Logs"));
      } else {
        this.exportDialog = true;
        this.finishDownload();
        return true;
      }
    },
    //Export pdf
    printDetails() {
      this.startDownload();
      let response = [];
      response = this.buildHtmlTable(this.transitOrderData);
      this.pdfName =
        "Transit_Orders_Logs_" + new Date().toISOString().replace("T", "_").replace("Z", "").replace(".", "").replaceAll("-", "_") + ".pdf";
      html2pdf(response, {
        margin: 0.5,
        filename: this.pdfName,
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { dpi: 190, letterRendering: true },
        jsPDF: { unit: "in", format: "letter", orientation: "landscape" },
      });
      this.finishDownload();
    },
    buildHtmlTable(data) {
      const table = document.createElement("table");
      table.style.borderCollapse = "collapse";
      table.style.width = "100%";
      table.style.fontSize = "9px";
      table.style.tableLayout = "auto";
      const thead = document.createElement("thead");
      const headerRow1 = document.createElement("tr");
      const mainHeaders = [
        "TRO Number",
        "RLP Number",
        "Status",
        "Project",
        "Ship Method",
        "Devices Shipped",
        "Devices Accepted",
        "Devices Rejected",
        "Update Message",
        "Update Details",
      ];
      mainHeaders.forEach((text) => {
        const th = document.createElement("th");
        th.innerText = text;
        th.rowSpan = 2;
        styleHeaderCell(th);
        headerRow1.appendChild(th);
      });
      // Devices Group Header
      const devicesTh = document.createElement("th");
      devicesTh.innerText = "Devices";
      devicesTh.colSpan = 5;
      styleHeaderCell(devicesTh);
      headerRow1.appendChild(devicesTh);
      thead.appendChild(headerRow1);
      const headerRow2 = document.createElement("tr");
      const deviceHeaders = ["Serial Number", "Shipped Date", "Status", "Updated", "Update Comments"];
      deviceHeaders.forEach((text) => {
        const th = document.createElement("th");
        th.innerText = text;
        styleHeaderCell(th);
        headerRow2.appendChild(th);
      });
      thead.appendChild(headerRow2);
      table.appendChild(thead);
      const tbody = document.createElement("tbody");
      data.forEach((item) => {
        const devices = item.devices?.length ? item.devices : [{}];
        devices.forEach((device) => {
          const tr = document.createElement("tr");
          const rowData = [
            item.tro_number,
            item.rlp_number,
            item.status,
            item.project,
            item.ship_method,
            item.devices_shipped,
            item.devices_accepted,
            item.devices_rejected,
            item.update_message,
            item.update_details,
            device.serial_number || "",
            device.shipped_date || "",
            device.status || "",
            device.updated || "",
            device.update_comments || "",
          ];
          rowData.forEach((value, index) => {
            const td = document.createElement("td");
            td.innerText = value || "";
            td.style.border = "1px solid black";
            td.style.padding = "4px";
            td.style.wordBreak = "break-word";
            if (index === 10) {
              td.style.backgroundColor = "#D3D3D3";
            }
            tr.appendChild(td);
          });
          tbody.appendChild(tr);
        });
      });
      table.appendChild(tbody);
      return table;
      function styleHeaderCell(th) {
        th.style.border = "1px solid black";
        th.style.padding = "5px";
        th.style.backgroundColor = "#005ba8";
        th.style.color = "white";
        th.style.textAlign = "center";
        th.style.verticalAlign = "middle";
      }
    },
    addAllColumnHeaders(response, table) {
      let columnSet = [];
      let tr = this.trTag.cloneNode(false);
      for (var i = 0, l = response.length; i < l; i++) {
        for (var key in response[i]) {
          if (columnSet.indexOf(key) === -1) {
            if (key != "tid") {
              columnSet.push(key);
              var th = this.thTag.cloneNode(false);
              th.style.border = "1px solid black";
              th.setAttribute("padding", "5px");
              th.style.borderLeft = "none";
              th.style.borderBottom = "none";
              th.style.backgroundColor = "#005ba8";
              th.style.color = "white";
              if (key == "tro_number") key = "TRO Number";
              if (key == "rlp_number") key = "RLP Number";
              if (key == "status") key = "Status";
              if (key == "project") key = "Project";
              if (key == "ship_method") key = "Ship Method";
              if (key == "devices_shipped") key = "Devices Shipped";
              if (key == "devices_accepted") key = "Devices Accepted";
              if (key == "progress") key = "Progress";
              th.appendChild(document.createTextNode(key));
              tr.appendChild(th);
            }
          }
        }
      }
      table.appendChild(tr);
      return columnSet;
    },
    //Start the Loader when excel process starts
    startDownload() {
      let LoaderDialog = {
        visible: true,
        title: "Please Wait...",
      };
      this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
    },
    // end the Loader when the process is completed
    finishDownload() {
      let LoaderDialog = {
        visible: false,
        title: "Please Wait...",
      };
      this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
    },
    //Add or remove Favourite
    addFav() {
      this.showAdd = !this.showAdd;
      AddFavourite.add_remove_Favourite(this.showAdd, this.userId, this.route);
    },
  },
  components: {
    breadcrumbComp,
  },
};
